module.exports = __webpack_public_path__ + "static/media/optimism.0103186d.svg";